import { fetchDatas, fetchData, createData, updateData, removeData, fetchApi } from '../reduxActions'
import { generateTypeName, generateTypeFunctions } from '../reduxTypes'

import uploadsForS3 from '../../util/uploadsForS3'
import { checkAppActions } from '../App/AppActions'

// Export Constants
const NAME_TYPE = ['SITES', 'SITE']
const name = "sites"

// Type Names and Type Functions
export const { ADDS, ADDS_MORE, ADD, UPDATE, REMOVE } = generateTypeName(NAME_TYPE)
export const { adds, adds_more, add, update, remove } = generateTypeFunctions(NAME_TYPE)

// Actions
import { adds as addBusinesses } from '../Businesses/BusinessesActions'
import { adds as addSettings } from '../Settings/SettingsActions'
import { adds as addCustomers } from '../Customers/CustomersActions'
import { adds as addPages } from '../Pages/PagesActions'
import { adds as addProducts } from '../Products/ProductsActions'
import { _GET_AUTH } from '../Auth/AuthActions'


// Actions Other
export const checkUsernameDuplicateSite = (params = {}) => dispatch => {
  return fetchApi({
    dispatch,
    params,
    api: `${name}-check-username-duplicate?${params.query}`
  })
}

export const checkDomianDuplicateSite = (params = {}) => dispatch => {
  return fetchApi({
    dispatch,
    params,
    api: `${name}-check-domain-duplicate?${params.query}`
  })
}

export const fetchSiteForUser = (params = {}) => dispatch => {
  return fetchData({
    dispatch,
    params,
    api: `${name}-for-user`,
    addMultiple: [
      { storeName: 'sites', add },
      { storeName: 'pages', add: addPages },
      { storeName: 'businesses', add: addBusinesses },
      { storeName: 'settings', add: addSettings },
      { storeName: 'customers', add: addCustomers },
      //{ storeName: 'products', add: addProducts },
      { storeName: 'auth', add: _GET_AUTH },
    ]
  })
}

export const fetchDomainDetails = (sites_id, params = {}) => dispatch => {
  return fetchData({
    dispatch,
    params,
    api: `domain-details/${sites_id}`
  })
}

export const fetchSubdomainDetails = (sites_id, params = {}) => dispatch => {
  return fetchData({
    dispatch,
    params,
    api: `subdomain-details/${sites_id}`
  })
}


// Actions Default
export const fetchSites = (businesses_id, params = {}) => dispatch => {
  return fetchDatas({
    dispatch,
    params,
    api: `${name}/${businesses_id}`,
    add: adds,
    addMore: adds_more
  })
}

export const fetchSite = (businesses_id, _id, params = {}) => dispatch => {
  return fetchData({
    dispatch,
    params,
    api: `${name}/${businesses_id}/${_id}`,
    add: add
  })
}

export const createSite = (businesses_id, params) => dispatch => {
  return createData({
    dispatch,
    params,
    api: `${name}/${businesses_id}/create`,
    add: add
  })
}

export const updateSite = (businesses_id, _id, params) => dispatch => {
  return updateData({
    dispatch,
    params,
    api: `${name}/${businesses_id}/${_id}`,
    update: update,
    updateId: _id
  })
}

/*export const uploadImagesSite = (businesses_id, sites_id, files, prefix, params) => dispatch => {
  checkAppActions(dispatch, params, 'start')
  uploadsForS3(files, prefix, params.progressId, dispatch).then(val => {
    val.map(paths => {
      params.body.paths = paths
      dispatch(updateSite(businesses_id, sites_id, params))
    })
  })
}*/

export const uploadImagesSite = (businesses_id, _id, files, prefix, params) => dispatch => {
  checkAppActions(dispatch, params, 'start')

  return new Promise(resolve => {
    uploadsForS3(files, prefix, params.progressId, dispatch).then(val => {
      val.map(paths => {
        params.body.paths = paths

        return dispatch(updateSite(businesses_id, _id, params)).then(res => {
          if (res.success) {
            res.paths = paths
          }

          resolve(res)
        })
      })
    })
  })
}

export const removeSite = (businesses_id, _id, params) => dispatch => {
  return removeData({
    dispatch,
    params,
    api: `${name}/${businesses_id}/${_id}`,
    remove: remove,
    deleteId: _id
  })
}
